import { render, staticRenderFns } from "./WordRecognitionTutorial.vue?vue&type=template&id=56b52ba7&scoped=true&"
import script from "./WordRecognitionTutorial.vue?vue&type=script&lang=js&"
export * from "./WordRecognitionTutorial.vue?vue&type=script&lang=js&"
import style0 from "./WordRecognitionTutorial.vue?vue&type=style&index=0&id=56b52ba7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b52ba7",
  null
  
)

export default component.exports